import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import staticIndex from '@/components/wxlogin'
import ykylogin from '@/components/ykylogin'
import ykyCodeIndex from '@/components/ykyCodeIndex'
import activity from '@/components/activity'
import productDel from '@/components/productDel'
import cart from '@/components/cart'
import exchangeSuccess from '@/components/exchangeSuccess'
import orderDel from '@/components/orderDel'
import exchangeList from '@/components/exchangeList'

import inspectionReport from '@/components/inspectionReport'

import userFeedback from '@/components/userFeedback'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path:'/wxlogin',
      name:'wxlogin',
      component: staticIndex
    },
    {
      path:'/ykycode',
      name:'ykylogin',
      component: ykylogin
    },
    {
      path:'/ykyCodeIndex',
      name:'ykyCodeIndex',
      component: ykyCodeIndex
    },
    {
      path:'/activity',
      name:'activity',
      component: activity
    },
    {
      path:'/productDel',
      name:'productDel',
      component: productDel
    },
    {
      path:'/cart',
      name:'cart',
      component: cart
    },
    {
      path:'/exchangeSuccess',
      name:'exchangeSuccess',
      component: exchangeSuccess
    },
    {
      path:'/orderDel',
      name:'orderDel',
      component: orderDel
    },
    {
      path:'/exchangeList',
      name:'exchangeList',
      component: exchangeList
    },
     {
      path:'/inspectionReport',
      name:'检验报告',
      component: inspectionReport
    },
     {
      path:'/userFeedback',
      name:'用户反馈',
      component: userFeedback
    },
  ]
})
